// extracted by mini-css-extract-plugin
export var author = "author-module--author--22c5f";
export var authors = "author-module--authors--6ed7a";
export var category = "author-module--category--7b822";
export var dot = "author-module--dot--c1425";
export var headline = "author-module--headline--90f71";
export var headlinePost = "author-module--headline-post--d5a71";
export var image = "author-module--image--9a60e";
export var info = "author-module--info--a5111";
export var large = "author-module--large--5a2eb";
export var meta = "author-module--meta--6d559";
export var name = "author-module--name--070f5";
export var paragraph = "author-module--paragraph--90ec8";
export var position = "author-module--position--82ec3";
export var profilePictureWrapper = "author-module--profile-picture-wrapper--d72a1";
export var seeAll = "author-module--see-all--d8a7f";
export var small = "author-module--small--348d4";